module.exports = __webpack_public_path__ + "img/34_45.635b0c8f.png";